import React from 'react';
import {apiVariables} from '../utils/variables'

export class Login extends React.Component{
    constructor(props){
        super(props)
        this.tryLogin = this.tryLogin.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)
        this.state = {
            message: null
        }
    }
    handleKeyPress(target) {
        if(target.charCode===13){
                this.tryLogin();    
        }
    
    }
    tryLogin(){
        fetch(//TODO REPLACE WHEN MOVING OVER TO LIVE
            apiVariables.apiLink + "login",{
            method: 'POST',
            headers: apiVariables.headers,
            credentials: apiVariables.credentials,
            body:  JSON.stringify({username: this.username.value,
                password: this.password.value})
            },
            
        ).then((res)=>{
            if(res.status === 200){
                this.props.login();
                window.location.href = "/";
            }
            else{
                this.setState({message: res.statusText})
            }
        })
    }
    render(){
        return (
        <div className="container"  onKeyPress={this.handleKeyPress}>
            <div className="col-md-4"></div>
            <div className="col-md-4">
            <h1 className="form-heading">SolutionMonitor</h1>
            <div className="login-form">
                <div className="main-div">
                    <div className="panel">
                        <p>Please enter your username and password</p>
                    </div>
                    <form id="Login" style={{marginBottom: 20}}>
                        <div className="form-group">
                            <input type="text" className="form-control" id="inputUsername" placeholder="Usernames" ref={(input)=> this.username = input}/>
                        </div>
                        <div className="form-group">
                            <input type="password" className="form-control" id="inputPassword" placeholder="Password" ref={(input)=> this.password = input}/>
                        </div>
                        
                        <input type="button" className="btn btn-primary" value="Login" onClick={this.tryLogin}/>
                    </form>
                    {this.state.message ? <div className="alert alert-warning col-md-12">{this.state.message}</div>: null}
                    </div>
                </div>
            </div>
        </div>


        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/login.js